import accordion from "./accordion";

export default function LatestRaceResults(){
  const timeStamp = Date.now()
  let RaceTitle = ``
  const latestResults450 = `https://data-aws.amaproracing.com/api/overallresults/latest/XC/m1`
  const latestResults250 = `https://data-aws.amaproracing.com/api/overallresults/latest/XC/m2`

  $('.result-trigger').click(function(e){
    e.preventDefault()
    const target = $(this).attr('data-target')

    $('.result-trigger').not(this).removeClass('active')
    $(this).addClass('active')

    $(`.results-content, .cta.results-content-450, .cta.results-content-250`).removeClass('active')
    $(`.results-content-${target}`).addClass('active')
    $(`.cta.results-content-${target}`).addClass('active')
  })

  function latestRaceResultsTitle(url,name) {
    $.ajax( {
      url: url,
      method: 'GET',
      dataType: 'json',
      error: () => {
        console.log("%cError fetching results!", "color: red; font-weight:700; font-size:20px;",);
      },
      success: data => {
        RaceTitle = data.EventName
        $('#results-page-title').html(RaceTitle)
      }
    });
  }

  latestRaceResultsTitle(latestResults450, '450')
  latestRaceResultsTitle(latestResults250, '250')

  LatestRaceResultsAll(latestResults450, '450')
  LatestRaceResultsAll(latestResults250, '250')

  function LatestRaceResultsAll(url, name){
	const resultsContainer = $(`#results-${name}`)
	
	if( ! resultsContainer.length ) {
		return;
	}	
		
    $.ajax( {
      url: url,
      method: 'GET',
      dataType: 'json',
      error: () => {
        console.log("%cError fetching results!", "color: red; font-weight:700; font-size:20px;",);
      },
      success: data => {
        const results = data.OverallResult

	
		
        let content = ''
        
        if ( results.length ) {
          let counterBottom = 1
          content += `<div class="race">`
          // content += `<h3 class="race-name">${raceName}</h3>`
          content += `<div class="race-bottom">`
          content += `<div class="race-accordion">`
          content += `<div class="accordion">`
            for ( let result of results ) {
              const position = result.OverallPos <= 9 ? `0${result.OverallPos}` : result.OverallPos
              const fullName = `${result.FullName}`
              const points = result.OverallPoints
              const m1 = result.Race1Pos
              const m2 = result.Race2Pos
              
              content += `<div class="item">`
              content += `  <div class="title">`
              content += `    <p class="position">${position}</p>`
              content += `    <p class="name">${fullName}</p>`
              // if (result.TeamName !== "None Listed"){
              //   content += `    <p class="team">${result.TeamName}</p>`
              // }
              content += `    <div class="positions">`
              content += `    <span class="position-item"><span class="label">M1</span>${m1}</span>`
              content += `    <span class="position-divider">/</span>`
              content += `    <span class="position-item"><span class="label">M2</span>${m2}</span>`
              content += `    </div>`
              content += `    <p class="points points-total">${points} pts</p>`
              content += `  </div>`
              content += `</div>`
              counterBottom++
            }
          content += `</div>`
          content += `</div>`
          content += `</div>`

          content += `</div>`
          
          resultsContainer.html(content)

          // accordion()
          
        }       

      }
    });
  }
  
  // latestRaceResultsTitle()
  // LatestRaceResultsAll()

}